import { Content, FileContent, Icon, Filename } from "../styles";
import { useSelector } from "react-redux";
import { State } from "conference/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIconFromMIME } from "../tools";
import { LinearProgress } from "@mui/material";
import { FileMessageContent } from "conference/components/meeting-page/room/types";
import { FormattedMessage } from "react-intl";

export const UploadingLocalContent = ({ content, messageId }: { content: FileMessageContent; messageId: string }) => {
    const uploaded = useSelector((state: State) => state.room.fileUploadProgress[messageId]) ?? 0;

    const progress = Math.round((uploaded / content.metadata.size) * 100);

    return (
        <Content>
            <FileContent>
                <Icon>
                    <FontAwesomeIcon size="2x" icon={getIconFromMIME(content.metadata?.mime_type)} />
                </Icon>
                <Filename>
                    <div style={{ marginBottom: "0.5em" }}>
                        <FormattedMessage
                            id="meetingPage.room.sidebar.chat.uploading"
                            defaultMessage="Uploading {file}..."
                            values={{ file: content.filename }}
                        />
                    </div>
                    <LinearProgress variant="determinate" value={progress} />
                </Filename>
            </FileContent>
        </Content>
    );
};

export default UploadingLocalContent;
